// src/i18n/es/activityMonitorAdditional.ts

export const activityMonitorAdditional = {
  actions: {
    viewJourney: 'Ver journey completo',
  },
  sessionStatus: {
    error: 'Error',
  },
  eventStatus: {
    error: 'Evento con error',
  },
  messages: {
    noEvents: 'Sin eventos registrados',
    moreEvents: 'eventos más',
  },
};

export default activityMonitorAdditional;
